import { DoorHeightEnum } from 'CoreAPI/Components/DoorHeightEnum';
import { RailTrackTypeEnum } from 'CoreAPI/Components/RailTrackTypeEnum';
import {
  MAX_SKYTTA_HEIGHT_HIGH_FRAME,
  MAX_SKYTTA_HEIGHT_LOW_FRAME,
  MIN_SKYTTA_HEIGHT_HIGH_FRAME,
  MIN_SKYTTA_HEIGHT_LOW_FRAME
} from 'products/doorframes';

export class RailCalculations {
  public static getRailTrackType(numberOfDoors: number) {
    if (numberOfDoors === 2 || numberOfDoors === 4) return RailTrackTypeEnum.TwoTrack;
    return RailTrackTypeEnum.ThreeTrack;
  }

  public static doUseThreeTrack(numberOfDoors: number) {
    return this.getRailTrackType(numberOfDoors) === RailTrackTypeEnum.ThreeTrack;
  }

  public static getUpperRailAttachmentHeight(doorHeightType: DoorHeightEnum, roomHeight: number) {
    switch (doorHeightType) {
      case DoorHeightEnum.Low:
        if (roomHeight < MIN_SKYTTA_HEIGHT_LOW_FRAME) {
          return MIN_SKYTTA_HEIGHT_LOW_FRAME;
        } else if (roomHeight > MAX_SKYTTA_HEIGHT_LOW_FRAME) {
          return MAX_SKYTTA_HEIGHT_LOW_FRAME;
        }
        return roomHeight;
      case DoorHeightEnum.High:
        if (roomHeight < MIN_SKYTTA_HEIGHT_HIGH_FRAME) {
          return MIN_SKYTTA_HEIGHT_HIGH_FRAME;
        } else if (roomHeight > MAX_SKYTTA_HEIGHT_HIGH_FRAME) {
          return MAX_SKYTTA_HEIGHT_HIGH_FRAME;
        }
        return roomHeight;
      default:
        throw Error(doorHeightType + ' not implemented');
    }
  }
}
